var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updated Dashbaord"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 79",
    d: "M-48 -104H239V918H-25.5C-37.9264 918 -48 907.926 -48 895.5V-104Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4853 3.74491C18.2188 1.38225 15.2053 0.0810547 12 0.0810547C8.79474 0.0810547 5.78119 1.38225 3.51471 3.74491C1.24823 6.10757 0 9.249 0 12.5903C0 15.9316 1.24823 19.073 3.51471 21.4356C5.78119 23.7983 8.79474 25.0995 12 25.0995C15.2053 25.0995 18.2188 23.7983 20.4853 21.4356C22.7518 19.073 24 15.9316 24 12.5903C24 9.249 22.7518 6.10757 20.4853 3.74491ZM5.20807 21.0583C5.60431 17.5042 8.53564 14.7602 12 14.7602C13.8263 14.7602 15.5436 15.5019 16.8354 16.8483C17.9268 17.9861 18.6151 19.4717 18.7921 21.0581C16.9519 22.6647 14.5825 23.6336 12 23.6336C9.41748 23.6336 7.04828 22.6649 5.20807 21.0583ZM12 13.2503C9.99042 13.2503 8.35529 11.5458 8.35529 9.45095C8.35529 7.3559 9.99042 5.65157 12 5.65157C14.0096 5.65157 15.6447 7.3559 15.6447 9.45095C15.6447 11.5458 14.0096 13.2503 12 13.2503ZM20.0024 19.8189C19.6441 18.3129 18.8969 16.9243 17.8297 15.8119C16.9655 14.9109 15.943 14.2351 14.8279 13.8115C16.1684 12.8638 17.051 11.2627 17.051 9.45095C17.051 6.54773 14.785 4.18564 12 4.18564C9.21497 4.18564 6.94904 6.54773 6.94904 9.45095C6.94904 11.2637 7.83234 12.8653 9.17395 13.8128C8.14801 14.2026 7.19861 14.8052 6.38177 15.5985C5.19891 16.7468 4.3775 18.211 3.99664 19.8178C2.38367 17.8794 1.40625 15.3517 1.40625 12.5903C1.40625 6.50097 6.15857 1.54698 12 1.54698C17.8414 1.54698 22.5938 6.50097 22.5938 12.5903C22.5938 15.3523 21.616 17.8806 20.0024 19.8189Z",
    fill: "#474747"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.cf32ffd51a75159a72e1db5c97f66977.svg";
export { ForwardRef as ReactComponent };